export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) {
    // Not on the landing page (e.g. a case study route) — navigate there via
    // react-router (no full reload); ScrollManager in App.js picks up the
    // hash and scrolls once Home has mounted.
    if (window.__navigate) {
      window.__navigate(`/#${id}`);
    } else {
      window.location.assign(`/#${id}`);
    }
    return;
  }
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(el, { offset: -20, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
